import { withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';

export const Caption = withStyles(({ palette, spacing }) => ({
  root: {
    marginBottom: spacing(1.5),
    display: 'block',
  },
}))(FsBody);
